import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generateQuote = (inquiry, customer, site, additionalCharges = {}) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;

  // Extract additional charges (for non-common inquiries, these come from modal)
  const transportCharge = parseFloat(additionalCharges.transportCharge || inquiry.transportCharge || 0);
  const loadingUnloadingCharge = parseFloat(additionalCharges.loadingUnloadingCharge || inquiry.loadingUnloadingCharge || 0);
  const loadingGst = parseFloat(additionalCharges.loadingGst || inquiry.loadingGst || 18);

  // Header
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 0);
  const quoteText = 'QUOTATION';
  const quoteY = 15;
  doc.text(quoteText, pageWidth / 2, quoteY, { align: 'center' });

  // Underline
  const quoteTextWidth = doc.getTextWidth(quoteText);
  doc.setLineWidth(0.5);
  doc.line(
    (pageWidth / 2) - (quoteTextWidth / 2),
    quoteY + 1,
    (pageWidth / 2) + (quoteTextWidth / 2),
    quoteY + 1
  );

  // GSTIN
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.text('GSTIN : 27AAIPF9571F1Z1', pageWidth / 2, 22, { align: 'center' });

  // Contact info
  doc.text('Mob : 9326260161          Email : saiply96@gmail.com', pageWidth / 2, 28, { align: 'center' });

  // Company name
  doc.setFontSize(22);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(200, 52, 43);
  doc.text('SAI PLYWOOD, HARDWARE', pageWidth / 2, 38, { align: 'center' });
  doc.text('& ALUMINIUM CENTRE', pageWidth / 2, 46, { align: 'center' });

  // Product description
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  const productDesc = 'All Kinds Of Plywood (Greenply, Century, Modak, SP Platinum Kenstar) All Kinds of Wood-CP,';
  const productDesc2 = 'BTC, Salwood, Laminates, Veneers, ACP, Fiber cement board & Aluminum Pipes';
  doc.text(productDesc, pageWidth / 2, 54, { align: 'center' });
  doc.text(productDesc2, pageWidth / 2, 58, { align: 'center' });

  // Shop address
  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');
  const shopAddress = 'Shop No. 10, Nivan Bldg., Plot No. 96, Opp. Podar Int School, Khar (W) Mumbai 400 052.';
  doc.text(shopAddress, pageWidth / 2, 64, { align: 'center' });

  // Horizontal line
  doc.setLineWidth(0.5);
  doc.setDrawColor(0, 0, 0);
  doc.line(15, 68, pageWidth - 15, 68);

  // Quote details
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 128);
  doc.text('QUOTATION NO.', 15, 75);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(inquiry.inquiryNumber || 'N/A', 15, 80);

  // Date
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(0, 0, 128);
  doc.text('Date :', pageWidth - 60, 75);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text(new Date().toLocaleDateString('en-IN'), pageWidth - 35, 75);

  // Customer name
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text('To,', 15, 88);
  doc.setFont('helvetica', 'bold');
  doc.text(customer.name || 'N/A', 15, 93);

  // Site address if available
  if (site && site.address) {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    const addressParts = [site.address, site.city, site.state, site.pincode].filter(Boolean);
    if (addressParts.length > 0) {
      doc.text(addressParts.join(', '), 15, 98);
    }
  }

  // Items table
  const tableStartY = site && site.address ? 106 : 100;

  // Prepare table data
  const columns = [
    { header: 'SR.', dataKey: 'sr' },
    { header: 'PARTICULARS', dataKey: 'particulars' },
    { header: 'QTY', dataKey: 'quantity' },
    { header: 'RATE', dataKey: 'rate' },
    { header: 'GST %', dataKey: 'gst' },
    { header: 'AMOUNT', dataKey: 'amount' }
  ];

  let subtotal = 0;
  const body = inquiry.items.map((item, index) => {
    const particulars = item.specification
      ? `${item.productName}\n${item.specification}`
      : item.productName;

    const rate = parseFloat(item.quotedPrice || 0);
    const qty = parseFloat(item.quantity || 0);
    const itemSubtotal = rate * qty;

    // Get GST percentage - only for common inquiries
    let gstPercentage = 0;
    if (inquiry.type === 'common') {
      gstPercentage = parseFloat(item.gstPercentage || 0);
    }
    // For non-common inquiries, no GST is shown (remains 0)

    subtotal += itemSubtotal;

    return {
      sr: (index + 1).toString(),
      particulars: particulars || 'N/A',
      quantity: `${qty} ${item.unit}`,
      rate: rate > 0 ? `Rs. ${rate.toFixed(2)}` : '-',
      gst: gstPercentage > 0 ? `${gstPercentage}%` : '-',
      amount: itemSubtotal > 0 ? `Rs. ${itemSubtotal.toFixed(2)}` : '-'
    };
  });

  // Calculate GST on items
  let itemsGST = 0;
  let chargesGST = 0;

  if (inquiry.type === 'common') {
    // For common inquiries, calculate GST item by item
    itemsGST = inquiry.items.reduce((sum, item) => {
      const rate = parseFloat(item.quotedPrice || 0);
      const qty = parseFloat(item.quantity || 0);
      const itemSubtotal = rate * qty;
      const gstPercentage = parseFloat(item.gstPercentage || 0);
      return sum + (itemSubtotal * gstPercentage / 100);
    }, 0);

    // Calculate GST on transport and loading charges for common inquiries
    const chargesAmount = transportCharge + loadingUnloadingCharge;
    chargesGST = (chargesAmount * loadingGst) / 100;
  }
  // For non-common inquiries, no GST is applied at all

  // Total GST (items + charges)
  const totalGST = itemsGST + chargesGST;

  const chargesAmount = transportCharge + loadingUnloadingCharge;
  const grandTotal = subtotal + chargesAmount + totalGST;

  // Calculate number of addon rows (summary rows) - MUST be after GST calculations
  let addonRowCount = 1; // Subtotal (always present)

  if (transportCharge > 0) addonRowCount++;
  if (loadingUnloadingCharge > 0) addonRowCount++;

  if (inquiry.type === 'common') {
    // For common inquiries, add GST rows
    if (itemsGST > 0) addonRowCount++; // GST on Items
    if (chargesGST > 0) addonRowCount++; // GST on Charges
    if (totalGST > 0) addonRowCount++; // Total GST
  }

  addonRowCount++; // GRAND TOTAL (always present)

  // Custom pagination logic: max 8 DATA rows per page, min 3 DATA rows per page
  // Row count = product items + addon rows (Subtotal, Transport, Loading, GST, GRAND TOTAL)
  // NOTE: Header row is NOT counted - it appears on every page automatically
  const distributeItems = (totalItems, addonRows, maxPerPage = 8, minPerPage = 3) => {
    const totalRows = totalItems + addonRows;

    if (totalRows <= maxPerPage) {
      // Everything fits on one page
      return [{ items: totalItems, includeAddons: true }];
    }

    const pages = [];
    let remainingItems = totalItems;

    // Distribute product items across pages
    while (remainingItems > 0) {
      const isLastPage = remainingItems <= maxPerPage;

      if (isLastPage) {
        // Last page: check if items + addons fit within limits
        const lastPageTotal = remainingItems + addonRows;

        if (lastPageTotal > maxPerPage) {
          // Too many rows on last page, redistribute
          const itemsForThisPage = maxPerPage;
          pages.push({ items: itemsForThisPage, includeAddons: false });
          remainingItems -= itemsForThisPage;
          // Next iteration will handle remaining items + addons
        } else if (lastPageTotal < minPerPage && pages.length > 0) {
          // Too few rows on last page, pull items from previous page
          const itemsNeeded = minPerPage - lastPageTotal;
          pages[pages.length - 1].items -= itemsNeeded;
          remainingItems += itemsNeeded;
          pages.push({ items: remainingItems, includeAddons: true });
          remainingItems = 0;
        } else {
          // Last page is within limits
          pages.push({ items: remainingItems, includeAddons: true });
          remainingItems = 0;
        }
      } else {
        // Not last page: fill up to max
        pages.push({ items: maxPerPage, includeAddons: false });
        remainingItems -= maxPerPage;
      }
    }

    return pages;
  };

  // Calculate pagination distribution (header NOT included in count)
  const itemsPerPage = distributeItems(body.length, addonRowCount);

  console.log('Total items:', body.length);
  console.log('Addon rows:', addonRowCount);
  console.log('Total rows:', body.length + addonRowCount);
  console.log('Pages distribution:', itemsPerPage);

  // Render tables page by page
  let currentItemIndex = 0;
  let currentY = tableStartY;
  let finalY;

  itemsPerPage.forEach((pageConfig, pageIndex) => {
    const isLastPage = pageIndex === itemsPerPage.length - 1;

    console.log(`Page ${pageIndex + 1}: items=${pageConfig.items}, includeAddons=${pageConfig.includeAddons}, startIndex=${currentItemIndex}`);

    // Get items for this page (data rows only, header added separately)
    const pageItems = body.slice(currentItemIndex, currentItemIndex + pageConfig.items);

    console.log(`  Rendering ${pageItems.length} items (from index ${currentItemIndex} to ${currentItemIndex + pageConfig.items - 1})`);

    // Draw items table for this page
    // Header appears on each page but is NOT counted in the row count
    doc.autoTable({
      startY: currentY,
      head: [columns.map(col => col.header)], // Header row (not counted in pagination)
      body: pageItems.map(row => columns.map(col => row[col.dataKey])), // Data rows (counted in pagination)
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        halign: 'center',
        lineWidth: 0.5,
        lineColor: [0, 0, 0]
      },
      styles: {
        fontSize: 10,
        cellPadding: { top: 4, right: 6, bottom: 4, left: 6 },
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        overflow: 'linebreak',
        cellWidth: 'wrap',
        valign: 'middle'
      },
      columnStyles: {
        0: {
          halign: 'center',
          cellWidth: 15,
          overflow: 'visible',
          fontSize: 8
        },
        1: { halign: 'left', cellWidth: 60, overflow: 'linebreak' },
        2: { halign: 'center', cellWidth: 25, overflow: 'visible' },
        3: { halign: 'right', cellWidth: 30, overflow: 'visible' },
        4: { halign: 'center', cellWidth: 20, overflow: 'visible' },
        5: { halign: 'right', cellWidth: 35, overflow: 'visible' }
      },
      margin: { bottom: 20 },
      pageBreak: 'avoid',
      didDrawCell: (data) => {
        // Make SR header text smaller
        if (data.section === 'head' && data.column.index === 0) {
          const cell = data.cell;
          // Clear the cell content
          doc.setFillColor(255, 255, 255);
          doc.rect(cell.x, cell.y, cell.width, cell.height, 'F');

          // Redraw borders
          doc.setDrawColor(0, 0, 0);
          doc.setLineWidth(0.5);
          doc.rect(cell.x, cell.y, cell.width, cell.height, 'S');

          // Redraw text with smaller font
          doc.setFontSize(7);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(0, 0, 0);
          doc.text('SR.', cell.x + cell.width / 2, cell.y + cell.height / 2 + 1.5, {
            align: 'center',
            baseline: 'middle'
          });
        }
      }
    });

    finalY = doc.lastAutoTable.finalY;
    currentItemIndex += pageConfig.items;

    // If this page should NOT include addons and not the last page, add new page
    if (!pageConfig.includeAddons && !isLastPage) {
      doc.addPage();
      currentY = tableStartY;
    }
  });

  // Summary rows - drawn ONCE after main table
  const summaryRows = [];

  // Subtotal (items only)
  summaryRows.push(['', '', '', { content: 'Subtotal', colSpan: 2, styles: { halign: 'right', fontStyle: 'bold' } }, `Rs. ${subtotal.toFixed(2)}`]);

  // Transport charge (if any)
  if (transportCharge > 0) {
    summaryRows.push(['', '', '', { content: 'Transport Charge', colSpan: 2, styles: { halign: 'right', fontStyle: 'normal' } }, `Rs. ${transportCharge.toFixed(2)}`]);
  }

  // Loading/Unloading charge (if any)
  if (loadingUnloadingCharge > 0) {
    summaryRows.push(['', '', '', { content: 'Loading/Unloading Charge', colSpan: 2, styles: { halign: 'right', fontStyle: 'normal' } }, `Rs. ${loadingUnloadingCharge.toFixed(2)}`]);
  }

  // GST breakdown - only for common inquiries
  if (totalGST > 0) {
    if (itemsGST > 0) {
      summaryRows.push(['', '', '', { content: 'GST on Items', colSpan: 2, styles: { halign: 'right', fontStyle: 'normal' } }, `Rs. ${itemsGST.toFixed(2)}`]);
    }

    if (chargesGST > 0) {
      summaryRows.push(['', '', '', { content: `GST on Charges (${loadingGst}%)`, colSpan: 2, styles: { halign: 'right', fontStyle: 'normal' } }, `Rs. ${chargesGST.toFixed(2)}`]);
    }

    // Total GST
    summaryRows.push(['', '', '', { content: 'Total GST', colSpan: 2, styles: { halign: 'right', fontStyle: 'bold' } }, `Rs. ${totalGST.toFixed(2)}`]);
  }

  // Grand Total
  summaryRows.push(['', '', '', { content: 'GRAND TOTAL', colSpan: 2, styles: { halign: 'right', fontStyle: 'bold', fillColor: [240, 240, 240] } }, `Rs. ${grandTotal.toFixed(2)}`]);

  doc.autoTable({
    startY: finalY,
    body: summaryRows,
    theme: 'grid',
    styles: {
      fontSize: 10,
      cellPadding: { top: 3, right: 6, bottom: 3, left: 6 },
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      overflow: 'linebreak',
      cellWidth: 'wrap',
      valign: 'middle'
    },
    columnStyles: {
      0: { halign: 'center', cellWidth: 15, overflow: 'visible' },
      1: { halign: 'left', cellWidth: 60, overflow: 'visible' },
      2: { halign: 'center', cellWidth: 25, overflow: 'visible' },
      3: { halign: 'right', cellWidth: 30, overflow: 'visible' },
      4: { halign: 'right', cellWidth: 20, fontStyle: 'bold', overflow: 'visible' },
      5: { halign: 'right', cellWidth: 35, fontStyle: 'bold', overflow: 'visible' }
    },
    margin: { bottom: 20 },
    pageBreak: 'avoid'
  });

  // Get final Y position after summary table
  const summaryFinalY = doc.lastAutoTable.finalY;
  const pageHeight = doc.internal.pageSize.height;

  // FOOTER POSITIONING - Always at bottom of last page
  // Work from bottom of page upwards
  const PAGE_BOTTOM_MARGIN = 10;

  // Calculate Y positions from bottom up
  let currentBottomY = pageHeight - PAGE_BOTTOM_MARGIN;

  // Signature (2 lines, 4 units each)
  const signatureLine2Y = currentBottomY;
  const signatureLine1Y = signatureLine2Y - 4;
  currentBottomY = signatureLine1Y - 7; // Gap before terms

  // Terms & Conditions (3 lines + header)
  const termsLine3Y = currentBottomY;
  const termsLine2Y = termsLine3Y - 4;
  const termsLine1Y = termsLine2Y - 4;
  const termsHeaderY = termsLine1Y - 5;
  currentBottomY = termsHeaderY - 8; // Gap before bank details or payment terms

  // Bank Details (if common inquiry) - positioned above terms with proper spacing
  let bankDetailsStartY = currentBottomY;
  if (inquiry.type === 'common') {
    // Bank details extend 13 units down (header + 3 lines at +5, +9, +13)
    // Position them at least 20 units above terms header to prevent overlap
    bankDetailsStartY = termsHeaderY - 20;
    currentBottomY = bankDetailsStartY - 5; // Gap above bank details
  }

  // Payment Terms (if present)
  let paymentTermsStartY = currentBottomY;
  if (inquiry.paymentDaysFromDelivery || inquiry.advancePaymentPercentage) {
    let paymentLinesCount = 0;
    if (inquiry.paymentDaysFromDelivery) paymentLinesCount++;
    if (inquiry.advancePaymentPercentage && inquiry.advancePaymentPercentage > 0) paymentLinesCount++;

    const paymentTermsHeight = 5 + (paymentLinesCount * 4); // Header + lines
    paymentTermsStartY = currentBottomY;
    currentBottomY = paymentTermsStartY - paymentTermsHeight;
  }

  // This is where footer actually starts (considering all sections)
  let footerTopY = termsHeaderY;
  if (inquiry.paymentDaysFromDelivery || inquiry.advancePaymentPercentage) {
    footerTopY = paymentTermsStartY;
  } else if (inquiry.type === 'common') {
    footerTopY = bankDetailsStartY;
  }

  // Check if summary table overlaps with footer
  const SAFETY_MARGIN = 10;
  if (summaryFinalY + SAFETY_MARGIN > footerTopY) {
    // Not enough space, add new page
    doc.addPage();
  }

  // DEBUG
  console.log('Summary ended at:', summaryFinalY);
  console.log('Footer starts at:', footerTopY);
  console.log('Page height:', pageHeight);
  console.log('Will add new page?', summaryFinalY + SAFETY_MARGIN > footerTopY);

  // Draw Payment terms if present
  if (inquiry.paymentDaysFromDelivery || inquiry.advancePaymentPercentage) {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text('Payment Terms:', 15, paymentTermsStartY);
    doc.setFont('helvetica', 'normal');

    let currentY = paymentTermsStartY + 5;

    if (inquiry.advancePaymentPercentage && inquiry.advancePaymentPercentage > 0) {
      doc.text(`${inquiry.advancePaymentPercentage}% advance payment`, 15, currentY);
      currentY += 4;
    }

    if (inquiry.paymentDaysFromDelivery) {
      doc.text(`Balance payment within ${inquiry.paymentDaysFromDelivery} days from delivery`, 15, currentY);
    }
  }

  // Bank details (only for common inquiries)
  if (inquiry.type === 'common') {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text('Bank Details:', 15, bankDetailsStartY);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.text('Account Holder Name: SAI PLYWOOD H/W & ALU CENTRE', 15, bankDetailsStartY + 5);
    doc.text('Account Number: 917020046489642', 15, bankDetailsStartY + 9);
    doc.text('IFSC Code: UTIB0001621', 15, bankDetailsStartY + 13);
  }

  // Terms and conditions
  doc.setFontSize(8);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  doc.text('Terms & Conditions:', 15, termsHeaderY);
  doc.text('• Taxes as applicable', 15, termsLine1Y);
  doc.text('• Damaged goods to be returned within 48hrs of delivery', 15, termsLine2Y);
  doc.text('• Once lifted from the shop not taken back', 15, termsLine3Y);

  // Signature
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(200, 52, 43);
  doc.text('For Sai Plywood, Hardware &', pageWidth - 15, signatureLine1Y, { align: 'right' });
  doc.text('Aluminium Centre', pageWidth - 15, signatureLine2Y, { align: 'right' });

  // Save
  const fileName = `Quote_${inquiry.inquiryNumber || 'QUOTE'}_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(fileName);
};
